import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";

import {
    motion,
    useScroll,
    useTransform,
    AnimatePresence,
} from "framer-motion";
import ScrollIcon from "./scrollIcon";
import useWindowSize from "@hooks/useWindowSize";
import Step1Icon from "./icons/step1";
import Step2Icon from "./icons/step2";
import Step3Icon from "./icons/step3";
import Step4Icon from "./icons/step4";
import Step5Icon from "./icons/step5";
import Step6Icon from "./icons/step6";
export default function FirstSection() {
    const windowSize = useWindowSize();
    const { scrollY } = useScroll();
    const rotateValue1 = useTransform(scrollY, [0, 800], [70, 0]);
    const rotateValue2 = useTransform(scrollY, [800, 1600], [70, -3]);
    const rotateValue3 = useTransform(scrollY, [1600, 2400], [70, -6]);
    const rotateValue4 = useTransform(scrollY, [2400, 3200], [70, -9]);
    const rotateValue5 = useTransform(scrollY, [3200, 4000], [70, -12]);
    const rotateValue6 = useTransform(scrollY, [4000, 4800], [70, -15]);
    const yValue1 = useTransform(scrollY, [0, 800], [1100, 0]);
    const yValue2 = useTransform(
        scrollY,
        [800, 1600],
        [
            700,
            windowSize.width < 1024
                ? -485
                : windowSize.width < 2024
                ? -500
                : -650,
        ],
    );
    const yValue3 = useTransform(
        scrollY,
        [1600, 2400],
        [
            700,
            windowSize.width < 1024
                ? -970
                : windowSize.width < 2024
                ? -1000
                : -1300,
        ],
    );
    const yValue4 = useTransform(
        scrollY,
        [2400, 3200],
        [
            700,
            windowSize.width < 1024
                ? -1455
                : windowSize.width < 2024
                ? -1500
                : -1950,
        ],
    );
    const yValue5 = useTransform(
        scrollY,
        [3200, 4000],
        [
            700,
            windowSize.width < 1024
                ? -1940
                : windowSize.width < 2024
                ? -2000
                : -2600,
        ],
    );
    const yValue6 = useTransform(
        scrollY,
        [4000, 4800],
        [
            700,
            windowSize.width < 1024
                ? -2425
                : windowSize.width < 2024
                ? -2500
                : -3250,
        ],
    );
    const list = [
        {
            title: "Step 1",
            slug: "step-1",
            icon: <Step1Icon />,
            description:
                "We start with a conversation to understand your KPIs and agree on a pricing model together, so our incentives stay aligned from day one.",
            bgColor: "#EEE1FF",
            marginTop: "-mt-0",
            zIndex: 1,
            yValue: yValue1,
            rotateValue: rotateValue1,
        },
        {
            title: "Step 2",
            slug: "step-2",
            icon: <Step2Icon />,
            description:
                "We build an Ideal Customer Profile (ICP), research audience behavior and intent, and craft targeting strategies across paid and organic search.",
            bgColor: "#E6D4FF",
            marginTop: " -mt-[400px]",
            zIndex: 2,
            yValue: yValue2,
            rotateValue: rotateValue2,
        },
        {
            title: "Step 3",
            slug: "step-3",
            icon: <Step3Icon />,
            description:
                "Every lead is AI-screened and human-verified, pre-qualified by geography, business type, and service need, so your team avoids wasted time. We deliver high-intent, compliant leads that match your criteria, or we swap or credit them, no hassle.",
            bgColor: "#DEC8FF",
            marginTop: " -mt-[400px]",
            zIndex: 3,
            yValue: yValue3,
            rotateValue: rotateValue3,
        },
        {
            title: "Step 4",
            slug: "step-4",
            icon: <Step4Icon />,
            description:
                "You send us regular disposition reports showing how each lead performed, contacted, not contacted, or converted, so we can see what's working.",

            bgColor: "#D2B8F9",
            marginTop: " -mt-[400px]",
            zIndex: 4,
            yValue: yValue4,
            rotateValue: rotateValue4,
        },
        {
            title: "Step 5",
            slug: "step-5",
            icon: <Step5Icon />,
            description:
                "We optimize campaigns based on that performance data, refining targeting and strategy, and adjust payouts against the KPIs we agreed on together.",

            bgColor: "#CBADFF",
            marginTop: " -mt-[400px]",
            zIndex: 5,
            yValue: yValue5,
            rotateValue: rotateValue5,
        },
        {
            title: "Step 6",
            slug: "step-6",
            icon: <Step6Icon />,
            description:
                "We repeat steps 2 through 5, refining continuously, until we reach an autopilot mode that works for both sides and consistently meets your KPIs.",
            bgColor: "#BF97FA",
            marginTop: " -mt-[400px]",
            zIndex: 6,
            yValue: yValue6,
            rotateValue: rotateValue6,
        },
    ];
    const [changeFixedStyle, setFixedStyle] = useState(false);
    const [hideScroll, setHideScroll] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 5189) {
                setFixedStyle(true);
            } else {
                setFixedStyle(false);
            }
            if (window.scrollY > 600) {
                setHideScroll(true);
            } else {
                setHideScroll(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            <section className={`${styles["bgStyle"]}  `}>
                <h1 className={` ${styles["howWeWorkStyle"]}`}>
                    How We Drive Leads
                </h1>
                <div className={styles["scrollStyleCenter"]}>
                    <motion.div
                        animate={{ y: [0, 15, 0] }}
                        transition={{
                            repeat: Infinity,
                            duration: 1.5,
                        }}
                        className={`${styles["scrollStyle"]} ${
                            hideScroll ? "hidden" : "block"
                        }`}
                    >
                        <ScrollIcon />
                    </motion.div>
                </div>

                <ul className={`${styles["cardsStyle"]}`}>
                    <AnimatePresence>
                        {list.map((el) => (
                            <motion.li
                                key={el.slug}
                                id={el.slug}
                                className={`rounded-[10px] w-full  3xl:w-[600px] lg:w-[458px] 3xl:h-[650px] h-[500px] text-[#341C4F] lg:px-10 px-5 lg:pt-10 pt-10 lg:pb-28  relative mx-auto `}
                                style={{
                                    backgroundColor: el.bgColor,
                                    zIndex: el.zIndex,
                                    y: el.yValue,
                                    rotate:
                                        windowSize.width < 1024
                                            ? 0
                                            : el.rotateValue,
                                }}
                            >
                                <span className=" flex justify-end ">
                                    {el.icon}
                                </span>
                                <h3 className="font-bold 3xl:text-6xl lg:text-4xl text-xl lg:leading-10 leading-8 mt-16 ">
                                    {el.title}
                                </h3>
                                <p className="3xl:text-2xl 3xl:leading-10 lg:text-lg mt-3  font-light">
                                    {el.description}
                                </p>
                            </motion.li>
                        ))}
                    </AnimatePresence>
                </ul>
            </section>
            <section
                className={`${changeFixedStyle ? "hidden" : styles["fixed"]}`}
            >
                <h1 className={` ${styles["howWeWorkStyle"]}`}>
                    How We Drive Leads
                </h1>
                <div className={styles["scrollStyleCenter"]}>
                    <motion.div
                        animate={{ y: [0, 15, 0] }}
                        transition={{
                            repeat: Infinity,
                            duration: 1.5,
                        }}
                        className={`${styles["scrollStyle"]} ${
                            hideScroll ? "hidden" : "block"
                        }`}
                    >
                        <ScrollIcon />
                    </motion.div>
                </div>

                <ul className={`${styles["cardsStyle"]}`}>
                    <AnimatePresence>
                        {list.map((el) => (
                            <motion.li
                                key={el.slug}
                                id={el.slug}
                                className={`rounded-[10px] w-full  3xl:w-[600px] lg:w-[458px] 3xl:h-[650px] h-[500px] text-[#341C4F] lg:px-10 px-5 lg:pt-10 pt-10 lg:pb-28  relative mx-auto `}
                                style={{
                                    backgroundColor: el.bgColor,
                                    zIndex: el.zIndex,
                                    y: el.yValue,
                                    rotate:
                                        windowSize.width < 1024
                                            ? 0
                                            : el.rotateValue,
                                }}
                            >
                                <span className=" flex justify-end ">
                                    {el.icon}
                                </span>
                                <h3 className="font-bold 3xl:text-6xl lg:text-4xl text-xl lg:leading-10 leading-8 mt-16 ">
                                    {el.title}
                                </h3>
                                <p className="3xl:text-2xl 3xl:leading-10 lg:text-lg mt-3  font-light">
                                    {el.description}
                                </p>
                            </motion.li>
                        ))}
                    </AnimatePresence>
                </ul>
            </section>
        </>
    );
}
